export default [
  /*{
    path: '/dashboard/analytics',
    name: 'dashboard-analytics',
    component: () => import('@/views/dashboard/analytics/Analytics.vue'),
    meta: {
      resource: 'DashboardAnalytics',
      action: 'read',
    },
  },
  {
    path: '/dashboard/ecommerce',
    name: 'dashboard-ecommerce',
    component: () => import('@/views/dashboard/ecommerce/Ecommerce.vue'),
    meta: {
      resource: 'DashboardEcommerce',
      action: 'read',
    },
  },*/
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/dashboard/stats/Stats.vue'),
    meta: {
      resource: 'DashboardStats',
      action: 'read',
    },
  },
]
